import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  IconButton,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SyncIcon from '@mui/icons-material/Sync';

interface MediaSyncDialogProps {
  open: boolean;
  onClose: () => void;
  onSyncMedia: () => void;
  isSyncing?: boolean;
}

export const MediaSyncDialog: React.FC<MediaSyncDialogProps> = ({
  open,
  onClose,
  onSyncMedia,
  isSyncing = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isSyncing ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="media-sync-dialog-title"
    >
      <DialogTitle
        id="media-sync-dialog-title"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        Media Out of Sync
        {!isSyncing && onClose && (
          <IconButton
            onClick={onClose}
            size="small"
            aria-label="close"
            disabled={isSyncing}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Your media files are out of sync with the server
        </Alert>

        <DialogContentText>
          The media information stored locally doesn&apos;t match what&apos;s on
          the server.
        </DialogContentText>

        <DialogContentText sx={{ mt: 2 }}>
          Syncing your media will refresh all media files from the server but
          some changes may have been lost.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isSyncing} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={onSyncMedia}
          variant="contained"
          color="primary"
          disabled={isSyncing}
          startIcon={isSyncing ? <CircularProgress size={16} /> : <SyncIcon />}
        >
          {isSyncing ? 'Syncing...' : 'Sync Media'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
